import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withKeys as _withKeys, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26de582e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "red-box"
}
const _hoisted_2 = {
  key: 1,
  class: "red-box",
  style: {"left":"300px"}
}
const _hoisted_3 = { id: "header1" }
const _hoisted_4 = { class: "cnt1 clearfix" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "本サイトについて（管理者様向け）", -1))
const _hoisted_9 = { class: "text1" }
const _hoisted_10 = {
  key: 0,
  class: "text2"
}
const _hoisted_11 = {
  key: 1,
  class: "text2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "ログアウト"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "ログアウト")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "cnt2 clearfix" }
const _hoisted_15 = {
  key: 0,
  class: "cnt3 clearfix"
}
const _hoisted_16 = { class: "com_search1" }
const _hoisted_17 = { class: "text1" }
const _hoisted_18 = ["id", "value"]
const _hoisted_19 = ["for"]
const _hoisted_20 = { class: "form1" }
const _hoisted_21 = {
  key: 0,
  class: "error-message"
}
const _hoisted_22 = { id: "fixed-header1" }
const _hoisted_23 = { class: "cnt1 clearfix" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "com_search1" }
const _hoisted_27 = { class: "text1" }
const _hoisted_28 = ["id", "value"]
const _hoisted_29 = ["for"]
const _hoisted_30 = { class: "form1" }
const _hoisted_31 = {
  key: 0,
  class: "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GlobalNavComponent = _resolveComponent("GlobalNavComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isAdmin && _ctx.businessDays)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 営業日切替中：" + _toDisplayString(_ctx.businessDays), 1))
      : _createCommentVNode("", true),
    (_ctx.systemEnvironment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.systemEnvironment), 1))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", null, [
            _createElementVNode("a", { href: _ctx.portalTopUrl }, [
              _createElementVNode("img", {
                src: _ctx.logoImage,
                alt: _ctx.altText,
                class: "logo1"
              }, null, 8, _hoisted_6)
            ], 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", null, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: _ctx.adminManualUrl,
                  class: "com_link1"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.agentCode) + " ： " + _toDisplayString(_ctx.agentName), 1),
            (_ctx.pseudoAgCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " ［ " + _toDisplayString(_ctx.pseudoAgCode) + " ： " + _toDisplayString(_ctx.pseudoAgName) + " ］ " + _toDisplayString(_ctx.invoiceNo), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.invoiceNo), 1))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              name: "btnLogout",
              class: "button1",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, _hoisted_13)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_GlobalNavComponent)
      ]),
      (!_ctx.isAdminPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectedCategoryName), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCategories, (category) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: category.categoryId
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "selectCatF1",
                            id: `selectCatF${category.categoryId}`,
                            value: category.categoryId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCategoryId) = $event))
                          }, null, 8, _hoisted_18), [
                            [_vModelRadio, _ctx.selectedCategoryId]
                          ]),
                          _createElementVNode("label", {
                            for: `selectCatF${category.categoryId}`
                          }, _toDisplayString(category.categoryName), 9, _hoisted_19)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  placeholder: "キーワードから検索",
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.siteSearch && _ctx.siteSearch(...args)), ["enter"])),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.serchKeyword) = $event)),
                  maxlength: "50"
                }, null, 544), [
                  [_vModelText, _ctx.serchKeyword]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  name: "btnSiteSearch",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.siteSearch && _ctx.siteSearch(...args)))
                })
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", null, [
            _createElementVNode("a", { href: _ctx.portalTopUrl }, [
              _createElementVNode("img", {
                src: _ctx.logoImage,
                alt: _ctx.altText,
                class: "logo1"
              }, null, 8, _hoisted_25)
            ], 8, _hoisted_24)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_GlobalNavComponent)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.selectedCategoryName), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCategories, (category) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: category.categoryId
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "selectCatF2",
                          id: `selectCatF${category.categoryId}`,
                          value: category.categoryId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCategoryId) = $event))
                        }, null, 8, _hoisted_28), [
                          [_vModelRadio, _ctx.selectedCategoryId]
                        ]),
                        _createElementVNode("label", {
                          for: `selectCatF${category.categoryId}`
                        }, _toDisplayString(category.categoryName), 9, _hoisted_29)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                name: "",
                value: "",
                placeholder: "キーワードから検索",
                onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.siteSearch && _ctx.siteSearch(...args)), ["enter"])),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.serchKeyword) = $event)),
                maxlength: "50"
              }, null, 544), [
                [_vModelText, _ctx.serchKeyword]
              ]),
              _createElementVNode("button", {
                type: "button",
                name: "btnSiteSearch",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.siteSearch && _ctx.siteSearch(...args)))
              })
            ])
          ])
        ])
      ]),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}